module.exports = __webpack_public_path__ + "static/media/car.2f3bd8a3.svg";